import { render, staticRenderFns } from "./StartForm.vue?vue&type=template&id=021dd6d1"
import script from "./StartForm.vue?vue&type=script&lang=js"
export * from "./StartForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports